<div class="row form-group" style="padding: 12px 0;">
    <input type="file" accept=".gif,.jpg,.jpeg,.png" class="button button-outline warning form-control" (change)="fileChangeEvent($event)" />
    <small class="form-text text-muted">Formati supportati: jpg, png, gif</small>
</div>
<div *ngIf="imageChangedEvent">
    <br />
            <div>
                <app-image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [containWithinAspectRatio]="containWithinAspectRatio"
                    [aspectRatio]="16 / 9"
                    [resizeToWidth]="900"
                    [cropperMinWidth]="128"
                    [onlyScaleDown]="true"
                    [roundCropper]="false"
                    [canvasRotation]="canvasRotation"
                    [transform]="transform"
                    [alignImage]="'center'"
                    [style.display]="showCropper ? null : 'none'"
                    (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady($event)"
                    (loadImageFailed)="loadImageFailed()"
                ></app-image-cropper>
            </div>
    <br />
    <div class="row justify-content-center" *ngIf="croppedImage">
        <a (click)="rotateLeft()"><img class="actions mr-1" src="assets\images\icons\rotateLeft.png"></a>
        <a (click)="rotateRight()"><img class="actions mr-1" src="assets\images\icons\rotateRight.png"></a>
        <a (click)="flipHorizontal()"><img class="actions mr-1" src="assets\images\icons\flipHorizontally.png"></a>
        <a (click)="flipVertical()"><img class="actions mr-1" src="assets\images\icons\flipVertically.png"></a>
        <a (click)="zoomOut()"><img class="actions mr-1" src="assets\images\icons\zoomOut.png"></a>
        <a (click)="zoomIn()"><img class="actions mr-1" src="assets\images\icons\zoomIn.png"></a>
    </div>
    <!-- <button type="button" class="button button-outline button-warning" (click)="toggleContainWithinAspectRatio()">{{containWithinAspectRatio?'Fill Aspect Ratio':'Contain Within Aspect Ratio'}}</button> -->
    <!-- <button type="button" class="button button-outline button-warning" (click)="resetImage()">Reset image</button> -->
    <br />
    <div class="row justify-content-center mb-2">
        <img class="cropped-image" [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" />
    </div>
</div>
